import {changeContext} from '../ui-change-context';

export const ChangeContextProvider = changeContext.Provider;
export const ChangeContextConsumer = changeContext.Consumer;

